import { Button, Grid2, Typography } from '@mui/material'
import { GRAY_COLORS } from 'asterX-UI'
import { UserInfo } from 'asterX-UI/DataDisplay'
import { ArrowLeftIcon } from 'asterX-UI/Icons'
import { PlusSquareIcon } from 'asterX-UI/Icons/PlusSquareIcon'
import CreateLoanApplicationModal from 'components/ClientModal/CreateLoanApplicationModal'
import { CustomTabs } from 'components/CustomTabs/CustomTabs'
import PageContainer from 'components/PageContainer/PageContainer'
import { ClientTab } from 'components/PageTabs/ClientTab'
import { TableTab } from 'components/PageTabs/TableTab'
import { useContractStore } from 'context/ContractStore'
import { getFomattedDate, getFullName, getFullValue } from 'lib/utils'
import { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router'
import { HOME_PATH } from 'routes/constants.routes'

const clientTabList = [
  {
    label: 'О клиенте',
    component: ClientTab
  },
  {
    label: 'Заявки',
    component: TableTab
  },
  {
    label: 'Контракты',
    component: TableTab
  },
  {
    label: 'Обеспечение',
    component: TableTab
  }
  /*{
    label: 'Мониторинг',
    component: null
  },
  {
    label: 'Лиды',
    component: null
  },
  {
    label: 'Статусы клиента',
    component: null
  },
  {
    label: 'Файлы',
    component: null
  },
  {
    label: 'Связи',
    component: null
  }*/
]

const Client = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const id = location.pathname.split('/').pop()

  const {
    contractStore: { client },
    contractStoreFunc: { getClientById }
  } = useContractStore()

  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (id) {
      getClientById(id)
    }
  }, [id])

  return (
    <PageContainer>
      <Grid2 size={{ xs: 12 }}>
        <Button size="small" onClick={() => navigate(HOME_PATH)} sx={{ display: 'flex', gap: '4px' }}>
          <ArrowLeftIcon />
          Назад
        </Button>
      </Grid2>
      <Grid2 container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid2>
          <Typography sx={{ fontSize: 14, color: GRAY_COLORS[600] }}> {getFomattedDate(client?.birthDate)}</Typography>
          <Typography sx={{ fontSize: 24, fontWeight: 600, color: GRAY_COLORS[900] }}>
            {getFullName(client?.firstName, client?.lastName, client?.patronymic)}
          </Typography>
        </Grid2>
        <Grid2>
          <UserInfo
            fullName={getFullName(client?.firstName, client?.lastName, client?.patronymic)}
            phone={client?.mobilePhone1?.toString()?.toPhone()}
            details={client}
            address={getFullValue(
              client?.country?.name,
              client?.region,
              client?.district,
              client?.street,
              client?.houseNumber
            )}
          />
        </Grid2>
      </Grid2>

      <Grid2 container justifyContent="space-between">
        <Grid2 display="flex" gap={2}>
          {/* <Button variant="grayText">
            <PrinterIcon />
            Печатные формы
          </Button> */}
        </Grid2>

        <Grid2 display="flex" gap={2} marginLeft={'auto'}>
          {/* <Button variant="grayText">
            <EditIcon />
            Загрузить документы
          </Button> */}

          <Button
            variant="contained"
            sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
            onClick={() => setIsModalOpen(true)}
          >
            <PlusSquareIcon />
            Создать заявку
          </Button>
        </Grid2>
      </Grid2>

      <Grid2 container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '24px' }}>
        <CustomTabs getTabs={clientTabList} page={'client'} />
      </Grid2>

      <CreateLoanApplicationModal open={isModalOpen} onClose={() => setIsModalOpen(false)} clientGuarantee={client} />
    </PageContainer>
  )
}

export default Client
